import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { pick, merge, isEmpty } from "lodash-es";
import React, { useContext, useEffect } from "react";
import { ConfigProvider as AntdConfigProvider } from "antd";
import { useAppStore } from "./store";
import { findIntlKeyByAntdLocaleKey, localesMap } from "./locales";
import MenuFooter from "./components/MenuFooter";
import { getGlobalShareConfigValueByKey, setGlobalShareConfig } from "./utils/globalShareConfig";
import { getProLayoutTheme } from "./theme/token";
import { LogoActionWithCollapseAction } from "./components/CollapseAction";
import { jsx as _jsx } from "react/jsx-runtime";
function pureCloneMenu(menus) {
  return menus.map(function (menu) {
    var newObj = pick(menu, ["key", "name", "icon", "path", "layout", "children", "parentId", "subAppName", "hideInMenu", "hideChildrenInMenu", "hideInBreadcrumb", "authority", "locale", "title", "access", "wrappers", "keepAlive", "microAppPath", "parentKeys", "menuGroup"]);
    if (newObj.children) {
      newObj.children = pureCloneMenu(newObj.children);
    }
    return newObj;
  });
}
var ComposeLayoutWithConfig = function ComposeLayoutWithConfig(props, ComposeLayout) {
  var appData = props.appData;
  var clientRoutes = appData.clientRoutes;
  var setMenus = useAppStore(function (s) {
    return s.setMenus;
  });
  var setFlatPathRoutes = useAppStore(function (s) {
    return s.setFlatPathRoutes;
  });
  var flatPathRoutes = useAppStore(function (s) {
    return s.flatPathRoutes;
  });
  var antdConfig = useContext(AntdConfigProvider.ConfigContext);
  var initConfig = function initConfig() {
    var _antdConfig$locale, _antdConfig$locale2, _props$layoutConfig$l, _props$layoutConfig$r;
    // 同步layoutConfig配置
    var defaultLocale = ((_antdConfig$locale = antdConfig.locale) === null || _antdConfig$locale === void 0 ? void 0 : _antdConfig$locale.locale) === "default" ? "zh-CN" : (_antdConfig$locale2 = antdConfig.locale) === null || _antdConfig$locale2 === void 0 ? void 0 : _antdConfig$locale2.locale;
    defaultLocale = !defaultLocale ? "zh-CN" : defaultLocale;
    var newLocales = merge({}, localesMap[findIntlKeyByAntdLocaleKey(defaultLocale)], (_props$layoutConfig$l = props.layoutConfig.locale) === null || _props$layoutConfig$l === void 0 ? void 0 : _props$layoutConfig$l.tabs);
    var cacheTabsMode = getGlobalShareConfigValueByKey("tabsMode");
    var tabsMode = props.layoutConfig.tabsMode === false ? false : true;
    if (window.__MICRO_APP_ENVIRONMENT__) {
      tabsMode = cacheTabsMode === false ? false : tabsMode;
    }
    useAppStore.setState({
      homePath: props.layoutConfig.homePath,
      locale: newLocales,
      tabsMode: tabsMode,
      globalBreadcrumb: props.layoutConfig.globalBreadcrumb
    });
    // 全局应用共享配置
    setGlobalShareConfig({
      tabsMode: tabsMode,
      splitMenus: props.proLayoutConfig.splitMenus || false
    });
    // 扁平化路由
    setFlatPathRoutes(((_props$layoutConfig$r = props.layoutConfig.route) === null || _props$layoutConfig$r === void 0 ? void 0 : _props$layoutConfig$r.children) || clientRoutes);
  };
  useEffect(function () {
    initConfig();
  }, []);

  // proLayout默认配置
  var proLayoutConfig = _objectSpread(_objectSpread({
    suppressSiderWhenMenuEmpty: true,
    collapsedButtonRender: false,
    logo: /*#__PURE__*/_jsx(LogoActionWithCollapseAction, {
      title: "\u661F\u661F\u5145\u7535"
    }),
    title: "星星充电",
    menuFooterRender: MenuFooter
  }, props.proLayoutConfig), {}, {
    menu: _objectSpread(_objectSpread({}, props.proLayoutConfig.menu), {}, {
      request: function () {
        var _request = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(params, menuItems) {
          var _props$proLayoutConfi;
          var newMenus, menuRequest, res;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                // antd会将menuItems的引反复赋值使用，这里深拷贝一下避免循环引用造成的性能问题
                newMenus = pureCloneMenu(menuItems);
                menuRequest = (_props$proLayoutConfi = props.proLayoutConfig.menu) === null || _props$proLayoutConfi === void 0 ? void 0 : _props$proLayoutConfi.request;
                if (!menuRequest) {
                  _context.next = 10;
                  break;
                }
                _context.next = 5;
                return menuRequest(params, newMenus);
              case 5:
                res = _context.sent;
                setMenus(res);
                return _context.abrupt("return", res);
              case 10:
                setMenus(newMenus);
                return _context.abrupt("return", newMenus);
              case 12:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function request(_x, _x2) {
          return _request.apply(this, arguments);
        }
        return request;
      }(),
      onLoadingChange: function onLoadingChange(loading) {
        var _props$proLayoutConfi2, _props$proLayoutConfi3;
        useAppStore.setState({
          menusLoading: loading
        });
        (_props$proLayoutConfi2 = props.proLayoutConfig.menu) === null || _props$proLayoutConfi2 === void 0 || (_props$proLayoutConfi3 = _props$proLayoutConfi2.onLoadingChange) === null || _props$proLayoutConfi3 === void 0 || _props$proLayoutConfi3.call(_props$proLayoutConfi2, loading);
      }
    })
  });
  proLayoutConfig.token = props.layoutConfig.proLayoutToken ? props.layoutConfig.proLayoutToken() : getProLayoutTheme();
  if (isEmpty(flatPathRoutes)) {
    return null;
  }
  return /*#__PURE__*/_jsx(ComposeLayout, _objectSpread(_objectSpread({}, props), {}, {
    proLayoutConfig: proLayoutConfig
  }));
};
export default ComposeLayoutWithConfig;